//Jquery
import "./jquery-global.js";
import $ from "jquery";
import 'zangdar/dist/zangdar.min';

export function initContactWizard() {

    let contactFormElement= document.getElementById('contactFormWizard');
    if (contactFormElement)
    {
        const wizard = new Zangdar('#contactFormWizard', {
            onStepChange: () => {
                onStepChange(wizard, 'contactWizardSteps')
            },
            customValidation(step, fields, form) {
                return $(form).valid();
            }
        })

        onStepChange(wizard, 'contactWizardSteps')   
    }
}

function onStepChange(wizard, selector) {
    const steps = wizard.getBreadcrumb()
    buildStepsBreadcrumb(wizard, selector, steps)
}

function buildStepsBreadcrumb(wizard, element, steps) {
    const $steps = document.getElementById(element)
    $steps.innerHTML = ''
    let counter = 1;
    for (let label in steps) {
        if (steps.hasOwnProperty(label)) {
            const $parent = document.createElement('div')
            const $a = document.createElement('a')
            const $textElement = `<div class="text-center fw-bold"><span class="d-inline-block d-md-block">${counter}</span><span class="d-inline-block d-md-none">.</span><span class="d-inline-block d-md-block">${label}</span></div>`;
            $parent.classList = `col ${(counter === 2 ? 'col-md-6 col-lg-8' : 'col-md-3 col-lg-2')} form-wizard-step text-start text-md-center ${steps[label].active ? '' : 'd-none d-md-block'}`
            $a.classList = 'd-inline-block w-auto text-decoration-none';
            if (steps[label].active) {
                $a.classList.add('step-active')
            }
            $a.setAttribute('href', '#')


            $a.innerHTML = $textElement
            $a.addEventListener('click', e => {
                e.preventDefault()
                wizard.revealStep(label)
            })
            $parent.appendChild($a)
            $steps.appendChild($parent)
            counter++;
        }
    }
}